import { Link } from 'react-router-dom';
import NibbletAppIcon from './icons/NibbletAppIcon';
import NibbletTextLogo from './icons/NibbletTextLogo';

function Nav() {
  return (
    <header className="header">
      <div className="nav">
        <Link to="/" className="logo">
          <NibbletAppIcon className="logo-icon" />
          <NibbletTextLogo className="logo-text" color={"#6C56FF"} />
        </Link>
      </div>
    </header>
  );
}

export default Nav;